export const SET_VALUE = "SET_VALUE";
export const RESET_QUESTIONS = "RESET_QUESTIONS";
